<template>
  <v-app>
    <v-snackbar v-model="snackbar" :color="color" top multi-line right :timeout="timeout">
      {{ message }}
      <v-btn flat @click="snackbar = false">Cerrar</v-btn>
    </v-snackbar>
    <router-view></router-view>
    <template v-if="$store.state.admin_original_token">
      <v-fab-transition>
        <v-btn
          id="admin_as_user"
          @click="backToAdminUser()"
          color="dark"
          dark
          fixed
          bottom
          right
          fab
        >
          <v-icon large>mdi-shield-account</v-icon>
        </v-btn>
      </v-fab-transition>
    </template>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  components: {},
  data() {
    return {
      snackbar: false,
      color: 'error',
      message: 'Se ha producido un error. Vuelva a intentarlo por favor.',
      timeout: 6000,
    };
  },
  mounted() {
    this.addPulseToTarget('#admin_as_user');
    var vm = this;
    this.$http.interceptors.response.use(
      response => {
        return response;
      },

      error => {
        // Una petición cancelada a propósito (p. ej. al cambiar un filtro) no es un error
        if (vm.$http.isCancel(error)) {
          return Promise.reject(error);
        }

        console.log('error', error);

        // handle error
        vm.snackbar = true;
        vm.color = 'error';
        if (
          error.response &&
          error.response.status === 401 &&
          error.response.config &&
          !error.response.config.__isRetryRequest
        ) {
          vm.logout();
        } else if (error.response && error.response.status === 450) {
          vm.message = 'La fecha de fin no permite generar facturas recurrentes';
        } else if (error.response) {
          // vm.message = error.response.data.message;
          vm.message = 'Se ha producido un error. Vuelva a intentarlo por favor.';
        }
      },
    );

    this.$http.interceptors.response.use(undefined, err => {
      return new Promise((resolve, reject) => {
        // console.log('error', err);

        if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
          // this.$store.dispatch('logout').then(() => {
          //   this.$router.push('/login')
          // });
          this.logout();
          resolve();
        } else {
          reject(err);
          throw err;
        }
      });
    });
  },
  computed: {
    isLoggedIn: function() {
      return this.$store.getters.isLoggedIn;
    },
  },
  methods: {
    addPulseToTarget(target) {
      let element = document.querySelector(target);
      if (element) {
        element.insertAdjacentHTML(
          'afterbegin',
          `<div class="circle-admin error" style="animation-delay: -3s"></div>
            <div class="circle-admin error" style="animation-delay: -2s"></div>
            <div class="circle-admin error" style="animation-delay: -1s"></div>
            <div class="circle-admin error" style="animation-delay: -0s"></div>`,
        );
      }
    },
    backToAdminUser: function() {
      if (this.$store.state.admin_original_token) {
        this.$store
          .dispatch('backToAdminLogin', this.$store.state.admin_original_token)
          .then(() => {
            // console.log({loginFromToken: res});
            this.$router.go('/dashboard');
          })
          .catch(() => {
            this.logout();
          });
      }
    },
    logout: function() {
      this.$store.dispatch('logout').then(() => {
        this.$router.push('/login');
      });
    },
  },
  created: function() {},
};
</script>

<style lang="scss">
@keyframes scaleInAdmin {
  from {
    transform: scale(0.1, 0.1);
    opacity: 0.6;
  }
  to {
    transform: scale(3.5, 3.5);
    opacity: 0;
  }
}

.circle-admin {
  border-radius: 50%;
  width: 30px;
  height: 30px;
  position: absolute;
  opacity: 0;
  animation: scaleInAdmin 4s infinite cubic-bezier(0.36, 0.11, 0.89, 0.32);
}

// .pulse {
//   display: block;
//   width: 1px;
//   height: 1px;
//   border-radius: 50%;
//   cursor: pointer;
//   box-shadow: 0 0 0 rgba(0, 175, 168, 0.6);
//   animation: pulse 2s infinite;
//   position: absolute;
// }
// .pulse:hover {
//   animation: none;
// }
</style>
